export default {
  computed: {
    customeTheme() {
      return {
        '--background-color': localStorage.getItem('background'),
        '--icon-color': localStorage.getItem('iconColor'),
        '--dark-color': localStorage.getItem('darkColor'),
        '--light-color': localStorage.getItem('lightColor'),
        '--text-light-color': localStorage.getItem('textLightColor'),
        '--modal-border-color': localStorage.getItem('modalBorder'),
        '--one-field-color': localStorage.getItem('oneFieldcolor'),
        '--new-call-effect': localStorage.getItem('newCallEffect'),
      };
    },
  },
};
